export interface MaterialOption {
    value: string;
    label: string;
}

export interface MaterialInfo {
    material: string;
    percentage: number;
}

export const MATERIAL_OPTIONS: MaterialOption[] = [
    { value: 'denim', label: '데님' },
    { value: 'chiffon', label: '시폰' },
    { value: 'cotton', label: '면' },
    { value: 'polyester', label: '폴리에스테르' },
    { value: 'brushed', label: '기모' },
    { value: 'polyurethane', label: '폴리우레탄' },
    { value: 'acrylic', label: '아크릴' },
    { value: 'nylon', label: '나일론' },
    { value: 'pocono_nylon', label: '포코노나일론' },
    { value: 'wool_hair', label: '울/모' },
    { value: 'spandex', label: '스판덱스' },
    { value: 'leather', label: '가죽' },
    { value: 'angora', label: '앙고라' },
    { value: 'alpaca', label: '알파카' },
    { value: 'silk', label: '견' },
    { value: 'rayon', label: '레이온/인견' },
    { value: 'viscose', label: '비스코스' },
    { value: 'silk2', label: '실크' },
    { value: 'tencel', label: '텐셀' },
    { value: 'modal', label: '모달' },
    { value: 'cashmere', label: '캐시미어' },
    { value: 'mink', label: '밍크' },
    { value: 'rabbit_fur', label: '토끼털' },
    { value: 'llama', label: '라마' },
    { value: 'raccoon_fur', label: '라쿤퍼' },
    { value: 'fox_fur', label: '폭스퍼' },
    { value: 'linen', label: '마/리넨' },
    { value: 'jijimi', label: '지지미' },
    { value: 'faux_fur', label: '인조퍼' },
    { value: 'faux_leather', label: '인조가죽(합성피혁)' },
    { value: 'suede', label: '스웨이드' },
    { value: 'corduroy', label: '코듀로이' },
    { value: 'satin', label: '새틴' },
    { value: 'velvet', label: '벨벳' },
    { value: 'neoprene', label: '네오프렌' },
    { value: 'mohair', label: '모헤어' },
    { value: 'waxed_cotton', label: '왁스드코튼' },
    { value: 'polyamide', label: '폴리아미드' },
    { value: 'lyocell', label: '리오셀' },
    { value: 'sharkskin', label: '샤크스킨' },
    { value: 'acetate', label: '아세테이트' },
    { value: 'triacetate', label: '트리아세테이트' },
    { value: 'seersucker', label: '시어서커' },
    { value: 'coolmax', label: '쿨맥스' },
    { value: 'mesh', label: '망사, 메시' },
    { value: 'trizar', label: '트라이자' },
    { value: 'other', label: '기타' },
];

export const materialValueToLabel = (value: string): string => {
    const found = MATERIAL_OPTIONS.find((m) => m.value === value);
    return found ? found.label : value;
};
